<template>
  <div class="row">
    <div class="col-md-12">
      <div class="box box-primary">
        <div class="box-header with-border">
          <h3 class="box-title">Create Store</h3>
          <div class="box-tools pull-right">
            <button type="button" class="btn btn-box-tool" data-widget="collapse"><i class="fa fa-minus"></i>
            </button>
          </div>
        </div>
        <div class="box-body">
          <div>
            <div class="row">
              <div class="col-lg-4 col-sm-6">
                <div class="form-group">
                  <label for="store_number">{{'store_number' | translate}}</label>
                  <input type="text" v-validate="'required'" :data-vv-as="'store_number' | translate" class="form-control" name="store_number" :placeholder="'store_number' | translate" v-model="storeData.store_number">
                  <span v-show="errors.has('store_number')" class="small text-danger">{{ errors.first('store_number') }}</span>
                </div>
              </div>
              <div class="col-lg-4 col-sm-6">
                <div class="form-group">
                  <label for="erp_store_id">{{'erp_store_id' | translate}}</label>
                  <input type="text" v-validate="'required'" :data-vv-as="'erp_store_id' | translate" class="form-control" name="erp_store_id" :placeholder="'erp_store_id' | translate" v-model="storeData.erp_store_id">
                  <span v-show="errors.has('erp_store_id')" class="small text-danger">{{ errors.first('erp_store_id') }}</span>
                </div>
              </div>
              <div class="col-sm-6 col-lg-4">
                <div class="form-group">
                  <label for="order_email">{{'order_email' | translate}}</label>
                  <input class="form-control"  v-validate="'required|email'" :data-vv-as="'order_email' | translate" name="order_email" :placeholder="'order_email' | translate" type="text" v-model="storeData.order_email">
                  <span v-show="errors.has('order_email')" class="small text-danger">{{ errors.first('order_email') }}</span>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-4 col-sm-6">
                <div class="form-group">
                  <label for="contact_name">{{'contact_name' | translate}}</label>
                  <input class="form-control"  v-validate="'required'" :data-vv-as="'contact_name' | translate" name="contact_name" :placeholder="'contact_name' | translate" type="text" v-model="storeData.contact_name">
                  <span v-show="errors.has('contact_name')" class="small text-danger">{{ errors.first('contact_name') }}</span>
                </div>
              </div>
              <div class="col-lg-4 col-sm-6">
                <div class="form-group">
                  <label for="contact_email">{{'contact_email' | translate}}</label>
                  <input class="form-control"  v-validate="'required|email'" :data-vv-as="'contact_email' | translate" name="contact_email" :placeholder="'contact_email' | translate" type="text" v-model="storeData.contact_email">
                  <span v-show="errors.has('contact_email')" class="small text-danger">{{ errors.first('contact_email') }}</span>
                </div>
              </div>
              <div class="col-lg-4 col-sm-6">
                <div class="form-group">
                  <label for="contact_phone">{{'contact_phone' | translate}}</label>
                  <input class="form-control" v-validate="'required'" :data-vv-as="'contact_phone' | translate" name="contact_phone" :placeholder="'contact_phone' | translate" type="text" v-model="storeData.contact_phone">
                  <span v-show="errors.has('contact_phone')" class="small text-danger">{{ errors.first('contact_phone') }}</span>
                </div>
              </div>
            </div>
            <hr>
            <div class="row">
              <div class="col-sm-6 col-xs-12">
                <h4 class="page-header">
                  <i class="fa fa-file-text-o mr-5"></i> {{'store_address' | translate}}
                </h4>
                <div class="row">
                  <div class="col-xs-12">
                    <div class="form-group">
                      <label for="name">{{'shop_name' | translate}}</label>
                      <input class="form-control" v-validate="'required'" :data-vv-as="'shop_name' | translate" name="name" :placeholder="'shop_name' | translate" type="text" v-model="storeData.name">
                      <span v-show="errors.has('name')" class="small text-danger">{{ errors.first('name') }}</span>
                    </div>
                  </div>
                  <div class="col-sm-9 col-xs-12">
                    <div class="form-group">
                      <label for="street">{{'street' | translate}}</label>
                      <input class="form-control" v-validate="'required'" :data-vv-as="'street' | translate" name="street" :placeholder="'street' | translate" type="text" v-model="storeData.street">
                      <span v-show="errors.has('street')" class="small text-danger">{{ errors.first('street') }}</span>
                    </div>
                  </div>
                  <div class="col-sm-3 col-xs-12">
                    <div class="form-group">
                      <label for="street_no">{{'street_no' | translate}}</label>
                      <input class="form-control" v-validate="'required'" :data-vv-as="'street_no' | translate" name="street_no" :placeholder="'street_no' | translate" type="text" v-model="storeData.street_no">
                      <span v-show="errors.has('street_no')" class="small text-danger">{{ errors.first('street_no') }}</span>
                    </div>
                  </div>
                  <div class="col-sm-4 col-xs-12">
                    <div class="form-group">
                      <label for="zip_code">{{'zip_code' | translate}}</label>
                      <input class="form-control" v-validate="'required'" :data-vv-as="'zip_code' | translate" name="zip_code" :placeholder="'zip_code' | translate" type="text" v-model="storeData.zip_code">
                      <span v-show="errors.has('zip_code')" class="small text-danger">{{ errors.first('zip_code') }}</span>
                    </div>
                  </div>
                  <div class="col-sm-8 col-xs-12">
                    <div class="form-group">
                      <label for="city">{{'city' | translate}}</label>
                      <input class="form-control" v-validate="'required'" :data-vv-as="'city' | translate" name="city" :placeholder="'city' | translate" type="text" v-model="storeData.city">
                      <span v-show="errors.has('city')" class="small text-danger">{{ errors.first('city') }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-sm-6 col-xs-12">
                <h4 class="page-header">
                  <i class="fa fa-truck mr-5"></i> {{'shipping_store_address' | translate}}
                </h4>
                <div class="row">
                  <div class="col-xs-12">
                    <div class="form-group">
                      <label for="shipping_name">{{'shipping_name' | translate}}</label>
                      <input v-validate="'required'" class="form-control" name="shipping_name" :data-vv-as="'shipping_name' | translate" :placeholder="'shipping_name' | translate" type="text" v-model="storeData.shipping_name">
                      <span v-show="errors.has('shipping_name')" class="small text-danger">{{ errors.first('shipping_name') }}</span>
                    </div>
                  </div>
                  <div class="col-sm-9 col-xs-12">
                    <div class="form-group">
                      <label for="shipping_street">{{'shipping_street' | translate}}</label>
                      <input class="form-control" name="shipping_street" v-validate="'required'" :data-vv-as="'street' | translate" :placeholder="'street' | translate" type="text" v-model="storeData.shipping_street">
                      <span v-show="errors.has('shipping_street')" class="small text-danger">{{ errors.first('shipping_street') }}</span>
                    </div>
                  </div>
                  <div class="col-sm-3 col-xs-12">
                    <div class="form-group">
                      <label for="shipping_street_no">{{'shipping_street_no' | translate}}</label>
                      <input v-validate="'required'" class="form-control" name="shipping_street_no" :data-vv-as="'number' | translate" :placeholder="'shipping_street_no' | translate" type="text" v-model="storeData.shipping_street_no">
                      <span v-show="errors.has('shipping_street_no')" class="small text-danger">{{ errors.first('shipping_street_no') }}</span>
                    </div>
                  </div>
                  <div class="col-sm-4 col-xs-12">
                    <div class="form-group">
                      <label for="shipping_zip_code">{{'shipping_zip_code' | translate}}</label>
                      <input v-validate="'required'" class="form-control" name="shipping_zip_code" :data-vv-as="'shipping_zip_code' | translate" :placeholder="'shipping_zip_code' | translate" type="text" v-model="storeData.shipping_zip_code">
                      <span v-show="errors.has('shipping_zip_code')" class="small text-danger">{{ errors.first('shipping_zip_code') }}</span>
                    </div>
                  </div>
                  <div class="col-sm-8 col-xs-12">
                    <div class="form-group">
                      <label for="shipping_city">{{'shipping_city' | translate}}</label>
                      <input v-validate="'required'" class="form-control" name="shipping_city" :data-vv-as="'shipping_city' | translate" :placeholder="'shipping_city' | translate" type="text" v-model="storeData.shipping_city">
                      <span v-show="errors.has('shipping_city')" class="small text-danger">{{ errors.first('shipping_city') }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <hr>
            <div class="row">
              <div class="col-xs-6"></div>
              <div class="col-xs-6 text-right">
                <a @click="postData" class="btn btn-app btn-success" :class="{'disabled': errors.any()}">
                  <i class="fa fa-save"></i>{{'submit' | translate | capitalize}}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  module.exports = {
    props: ['storeData'],
    data () {
      return {}
    },
    methods: {
      postData () {
        this.$validator.validateAll(this.storeData)
          .then(result => {
            if (!result) {
              this.$emit('alert', 'error')
            } else {
              API.post(`accounting/companies/${this.$route.params.company_id}/stores`, this.storeData)
                .then(response => {
                  if (response.status === 201) {
                    this.$emit('alert', response)
                  }
                })
                .catch(error => {
                  this.$emit('alert', error)
                })
            }
          })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/tools/StoreCreate.vue